import { store } from '@core/Store'
import { selectPlayerSessionId } from '@core/Areas/Kambi/Store/selectors'
import { get } from '@classic/Foundation/Services/ApiService'

export const getFromKambiPlayerApi = async <T>({
  urlPath,
}: {
  urlPath: string
}): Promise<T | null> => {
  const playerSessionId = selectPlayerSessionId(store.getState())

  if (!playerSessionId) return null

  try {
    const response = await get<T>({
      url: `${window._kc.apiPlayerBaseUrl}${urlPath}`,
      opts: { headers: { authorization: `Bearer ${playerSessionId}` } },
    })

    return response
  } catch {
    return null
  }
}
